"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetsSettingsT = exports.ResetsSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const arms_mounting_reset_mode_js_1 = require("../../solarxr-protocol/rpc/arms-mounting-reset-mode.js");
class ResetsSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsResetsSettings(bb, obj) {
        return (obj || new ResetsSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsResetsSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ResetsSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    resetMountingFeet() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    armsMountingResetMode() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : arms_mounting_reset_mode_js_1.ArmsMountingResetMode.BACK;
    }
    yawResetSmoothTime() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    saveMountingReset() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    resetHmdPitch() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startResetsSettings(builder) {
        builder.startObject(5);
    }
    static addResetMountingFeet(builder, resetMountingFeet) {
        builder.addFieldInt8(0, +resetMountingFeet, +false);
    }
    static addArmsMountingResetMode(builder, armsMountingResetMode) {
        builder.addFieldInt8(1, armsMountingResetMode, arms_mounting_reset_mode_js_1.ArmsMountingResetMode.BACK);
    }
    static addYawResetSmoothTime(builder, yawResetSmoothTime) {
        builder.addFieldFloat32(2, yawResetSmoothTime, 0.0);
    }
    static addSaveMountingReset(builder, saveMountingReset) {
        builder.addFieldInt8(3, +saveMountingReset, +false);
    }
    static addResetHmdPitch(builder, resetHmdPitch) {
        builder.addFieldInt8(4, +resetHmdPitch, +false);
    }
    static endResetsSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createResetsSettings(builder, resetMountingFeet, armsMountingResetMode, yawResetSmoothTime, saveMountingReset, resetHmdPitch) {
        ResetsSettings.startResetsSettings(builder);
        ResetsSettings.addResetMountingFeet(builder, resetMountingFeet);
        ResetsSettings.addArmsMountingResetMode(builder, armsMountingResetMode);
        ResetsSettings.addYawResetSmoothTime(builder, yawResetSmoothTime);
        ResetsSettings.addSaveMountingReset(builder, saveMountingReset);
        ResetsSettings.addResetHmdPitch(builder, resetHmdPitch);
        return ResetsSettings.endResetsSettings(builder);
    }
    unpack() {
        return new ResetsSettingsT(this.resetMountingFeet(), this.armsMountingResetMode(), this.yawResetSmoothTime(), this.saveMountingReset(), this.resetHmdPitch());
    }
    unpackTo(_o) {
        _o.resetMountingFeet = this.resetMountingFeet();
        _o.armsMountingResetMode = this.armsMountingResetMode();
        _o.yawResetSmoothTime = this.yawResetSmoothTime();
        _o.saveMountingReset = this.saveMountingReset();
        _o.resetHmdPitch = this.resetHmdPitch();
    }
}
exports.ResetsSettings = ResetsSettings;
class ResetsSettingsT {
    constructor(resetMountingFeet = false, armsMountingResetMode = arms_mounting_reset_mode_js_1.ArmsMountingResetMode.BACK, yawResetSmoothTime = 0.0, saveMountingReset = false, resetHmdPitch = false) {
        this.resetMountingFeet = resetMountingFeet;
        this.armsMountingResetMode = armsMountingResetMode;
        this.yawResetSmoothTime = yawResetSmoothTime;
        this.saveMountingReset = saveMountingReset;
        this.resetHmdPitch = resetHmdPitch;
    }
    pack(builder) {
        return ResetsSettings.createResetsSettings(builder, this.resetMountingFeet, this.armsMountingResetMode, this.yawResetSmoothTime, this.saveMountingReset, this.resetHmdPitch);
    }
}
exports.ResetsSettingsT = ResetsSettingsT;
